import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { DraftSupportingDocumentDialogComponent } from '../draft-supporting-document-dialog/draft-supporting-document-dialog.component';
import { Logger } from '../../../../../../../infrastructure/logging/logger';
import { ImageUtility } from '../../../../../../../utilities/ImageUtility';
import { SupportingDocument } from '../../models/SupportingDocumentSection.model';
import { UpdateExistingSupportingDocumentDescriptionEvent } from '../../models/UpdateExistingSupportingDocumentDescriptionEvent.model';
import { padString } from '../../../../../../../utilities/StringUtility';

@Component({
  selector: 'app-supporting-document',
  templateUrl: './supporting-document.component.html',
  styleUrls: ['./supporting-document.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatIcon,
    MatTooltip
  ]
})
export class SupportingDocumentComponent {

  @Input() document!: SupportingDocument;
  @Input() showEditIcon = false;

  @Output() deleteEvent = new EventEmitter<string>();
  @Output() updateDescriptionEvent = new EventEmitter<UpdateExistingSupportingDocumentDescriptionEvent>();

  padString = padString;

  constructor(
    public imageUtility: ImageUtility,
    private readonly dialog: MatDialog,
    private readonly logService: Logger
  ) { }

  onEditClick(document: SupportingDocument) {
    const documentExtension = document.fileType.split('/')[1];
    const isImage = this.imageUtility.isImageFileType(documentExtension);

    const dialogRef = this.dialog.open(DraftSupportingDocumentDialogComponent, {
      width: '80vw',
      maxWidth: isImage ? '1000px' : '600px',
      data: {
        isImage: isImage,
        document: document
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      switch (result.action) {
        case 'delete':
          this.deleteEvent.emit(result.id);
          break;
        case 'description':
          this.updateDescriptionEvent.emit({ documentId: result.id, description: result.description });
          break;
        case 'close':
          break;
        default:
          this.logService.handleError(`Unknown supporting dialog return action: ${result.action}`, `Unknown supporting dialog return action: ${result.action}`, `Unknown supporting dialog return action: ${result.action}`);
      }
    });
  }
}